import React, { useState, useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { calendarUpdateWithAPIAction } from 'redux/reducers/calendar/actions'
import moment from 'moment-timezone'
import Calendar from '../components/Calendar/Calendar'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import { selectCalendarDateAction } from 'redux/reducers/calendar/actions'
import styles from './NewAddressEffective.module.scss'

const NewAddressEffectiveView = ({ i18n, t, setIsError }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [errMsg, setErrMsg] = useState('')

  const { newAddressEffective } = useSelector((state) => state.app)
  const { jointlyRegistered, registeredBusiness, driverLicence, registeredByName } = useSelector((state) => state.app.addressTypeChange)

  const isRMV = useMemo(() => {
    return driverLicence || registeredByName || jointlyRegistered || registeredBusiness
  }, [driverLicence, registeredByName, jointlyRegistered, registeredBusiness]);

  useEffect(() => {
    try {
      let min = moment().format('YYYY-MM-DD')
      let max = moment().add(2, 'months').format('YYYY-MM-DD')
      const moments = []
      for (let m = moment(min); m.diff(max, 'days') <= 0; m.add(1, 'days')) {
        moments.push(moment(m));
      }
      dispatch(calendarUpdateWithAPIAction(min, max, moments))
      dispatch(selectCalendarDateAction(min))
    } catch (err) {
      console.log(err)
    }
  }, [dispatch])

  const onNext = () => {
    if (!newAddressEffective) {
      setErrMsg(t('new_address_effective.no_effective_date_selected'))
    }
    history.push(`/${i18n.language}${t('routes.new_address')}`)
  }

  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>{t('new_address_effective.when_is_your')}</h1>
            </div>
          </div>
          {isRMV && (
            <div className="row">
              <div className="col-xs-12 col-lg-8">
                <div className={styles['warning-info-container']}>
                  <i aria-label={t('shared.warning')} className={"fa fa-exclamation-triangle error-indicator fa-2x has-warning errorAlert " + styles['warning-alert']} aria-hidden="true"></i>
                  <p>
                    <strong>{t('new_address_effective.rmv_processes_requests')}</strong>
                  </p>
                </div>
              </div>
            </div>
          )}

          <Calendar />
          <ContinueCancelButtons continueClick={onNext} errorText={errMsg} />
        </article>
      </main>
    </div>

  )
}

export default withTranslation('common')(NewAddressEffectiveView)
